import { render, staticRenderFns } from "./AddVerificationCodeDialog.vue?vue&type=template&id=732955bc&scoped=true&"
import script from "./AddVerificationCodeDialog.vue?vue&type=script&lang=js&"
export * from "./AddVerificationCodeDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddVerificationCodeDialog.vue?vue&type=style&index=0&id=732955bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732955bc",
  null
  
)

export default component.exports